import { Coordinate } from 'ol/coordinate';
import { BOUNDARY_MIN_VALID_AREA_SQR_METERS, MINIMUM_COORDINATES_FOR_VALID_BOUNDARY } from '../constants';
import { Mission, Zone, Boundary } from '../db';
import { KML_FEATURE_TYPE } from '../featureTypes';
import { MultiPolygonCoords } from '../types/types';
import { GeoDataUtilities } from '@rogoag/shared-ts';

export async function processMultipolygonCoords(mission: Mission, multiPolygonCoords: MultiPolygonCoords, zone: Zone) {
  const errorMessages: string[] = [];

  for (const polygonCoords of multiPolygonCoords) {
    // all simple polygons inside a polygon should have the same poly_id
    const polyId = mission.assign_id();

    for (const [i, simplePolygonCoords] of Object.entries(polygonCoords)) {
      const isOuterPolygon = parseInt(i) === 0;
      const validBoundary = simplePolygonCoords.length >= MINIMUM_COORDINATES_FOR_VALID_BOUNDARY;

      if (!validBoundary) {
        const errorMessage = `Boundary with index ${i} must have at least ${MINIMUM_COORDINATES_FOR_VALID_BOUNDARY} coordinates`;
        errorMessages.push(errorMessage);

        if (isOuterPolygon) {
          errorMessages.push(`Skipping entire polygon because outer boundary is invalid.`);
          break;
        }

        continue;
      }

      // Check the area
      const area = GeoDataUtilities.polygonArea(simplePolygonCoords);

      if (!Boundary.isBoundaryAreaValid(area)) {
        errorMessages.push(
          `One of the polygon's area is less than minimal (${Math.round(area).toLocaleString()} < ${BOUNDARY_MIN_VALID_AREA_SQR_METERS} m²), skipping it.`,
        );

        if (isOuterPolygon) {
          errorMessages.push(`Skipping entire polygon because outer boundary is invalid.`);
          break;
        }

        continue;
      }

      let processFunction: (
        isOuterPolygon: boolean,
        coordinates: Coordinate[],
        mission: Mission,
        polyId: number,
        outerZone: Zone,
      ) => Promise<void>;

      await processPolygonRegularly(
        isOuterPolygon,
        simplePolygonCoords.map((coord) => [coord[1], coord[0]]),
        mission,
        polyId,
        zone,
      );
    }
  }

  return errorMessages;
}

async function processPolygonRegularly(
  isOuterPolygon: boolean,
  coordinates: Coordinate[],
  mission: Mission,
  polyId: number,
  outerZone: Zone,
) {
  const newBoundary = Boundary.create();
  newBoundary.boundary_id = mission.assign_id();
  newBoundary.coordinates = coordinates;
  newBoundary.poly_id = polyId;

  if (isOuterPolygon) {
    newBoundary.OuterZone_id = outerZone.instance_id;
  } else {
    newBoundary.InnerZone_id = outerZone.instance_id;
  }

  newBoundary.simplify(0.5);
}
